import React, { Component } from 'react';
import { Form, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { TimelineChartPanel } from './TimelineChartPanel';
import { StackbarChartPanel } from './StackbarChartPanel';
import { DonutsChartPanel } from './DonutsChartPanel';

export class ChartPanel extends Component {

  constructor(props) {
    super(props);

    this.state={
      selectedChart: 'none'
    }
  }

  onSelectChange = (e) => {
    console.log('Hai selezionato il chart: ' + e.target.value);
    this.setState({
      selectedChart: e.target.value
    });
  }

  getSelectedChart = () => {
      switch(this.state.selectedChart) {
        case 'none':

          return '';

        case 'timeline':

          return (<TimelineChartPanel routesList={this.props.routesList} ></TimelineChartPanel>);

        case 'stackbar':

          return (<StackbarChartPanel routesList={this.props.routesList} ></StackbarChartPanel>);

          case 'donuts':

            return (<DonutsChartPanel routesList={this.props.routesList} ></DonutsChartPanel>);
        default:

          return '';
      }
  }

  render = () => {
    return (
      <span>
        {/*
        <span className="chart-selector-container">
          <Form inline >
            <FormGroup controlId="formControlsSelect" bsSize="small">
              <FormControl componentClass="select" placeholder="select a valid chart" value={this.state.selectedChart} onChange={this.onSelectChange} bsSize="small">
                <option value="none">Select a Chart</option>
                <option value="donuts">Donuts</option>
                <option value="timeline">Timeline</option>
                <option value="stackbar">StackBar</option>
              </FormControl>
            </FormGroup>
          </Form>
        </span>
        */}
        <span className="chart-container">
          {/*this.getSelectedChart()*/}
          <DonutsChartPanel routesList={this.props.routesList} ></DonutsChartPanel>
        </span>
      </span>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/ChartPanel.js